import { Spine } from '../spine';
import { Container } from '../pixiContainer';
import { iconStates, specialIconKeys } from '../../../constants/symbolsNames';

export const iconStateAnimations = {
  [iconStates.win]: 'win',
  [iconStates.idle]: 'idle',
  [iconStates.blur]: 'blur',
  [iconStates.noWin]: 'noWin',
  [iconStates.winPt1]: 'win_pt1',
};

export class SlotIcon extends Container {
  constructor(options) {
    super(options);
    const styles = { origin: 0.5, roundPixels: false };
    this.animationType = 'slotIcon';
    this.winParent = options.winParent;
    this.winFrameParent = options.winFrameParent;
    this.index = options.index;
    this.reelIndex = options.reelIndex;
    this.xPosition = options.xPosition;
    this.rowIndex = options.rowIndex;
    this.spinParent = this.parent;
    this.key = options.key;

    this.icon = this.addChild(
      new Spine({
        elementId: `${this.elementId}_Icon`,
        key: options.key,
        styles,
        slotSpineKey: options.key,
      })
    );
    this.iconWinBoard = this.addChild(
      new Spine({
        elementId: `${this.elementId}_Icon`,
        key: 'winSymbolBorder',
        styles,
      })
    );
    this.iconWinBoard.visible = false;
    this.iconNumber = options.key;
    this.loop = false;
    this.currentState = null;
    this.changeState(iconStates.idle);
    this.roundPixels = false;
    this.children.forEach((c) => {
      c.roundPixels = false;
    });
    this.xPosInReel = this.x;
    this.yPosInReel = this.y;
    this.yPosInWin = this.y;
    this.xPosInWin = this.x;
  }

  setWinContainerPositions(positions) {
    this.xPosInWin = positions.xInWin;
    this.yPosInWin = positions.yInWin;
  }

  changeIcon(newNumber, state = iconStates.idle, timeScale = 1) {
    if (newNumber === this.iconNumber) return;
    this.iconNumber = newNumber;
    this.key = newNumber;
    this.index = newNumber;
    this.icon.show();
    this.icon.changeTexture(this.iconNumber?.toString());
    this.changeState(state, timeScale);
  }

  changeState(state, loop = false, timeScale = 1) {
    this.currentState = state;
    this.icon.stop();
    this.changeToActualParent();
    if (this.icon) {
      const promise = new Promise((res) => {
        this.icon.addListener('complete', res);
      });
      this.icon.play(state, loop, timeScale);
      if (state !== iconStates.win) {
        this.iconWinBoard.visible = false;
      }
      this.icon.clearListeners();
      return promise;
    }
    return Promise.resolve(false);
  }

  changeBoardState(state) {
    if (state === iconStates.win) {
      this.changeToActualParent();
      this.iconWinBoard.play('winFrame');
      this.iconWinBoard.visible = true;
    } else {
      this.iconWinBoard.visible = false;
    }
    this.changeToActualParent();
  }

  addOnCompleteHandler(handler, context = null, once = false) {
    if (this.icon) {
      this.icon.addListener('complete', handler, context);
      const spine = this.icon;
      return () => {
        spine.removeListener('complete', handler, context);
      };
    }
    const hh = this.icon.loop ? 'onLoop' : 'onComplete';
    const a = once
      ? () => {
        handler.call(context);
        this.icon[hh] = null;
      }
      : () => {
        handler.call(context);
      };
    this.icon[hh] = a;
    return () => {
      this.icon[hh] = null;
    };
  }

  changeToActualParent() {
    const parent =
      (this.currentState === (iconStates.win || iconStates.winPt1)) && this.iconWinBoard.visible
        ? this.winParent
        : this.spinParent;
    if (parent !== this.parent) {
      if (parent === this.spinParent) {
        this.x = this.xPosInReel;
        this.y = this.yPosInReel;
      }
      if (parent === this.winParent) {
        this.x = this.xPosInWin;
        this.y = this.yPosInWin;
      }
      this.iconWinBoard.x = this.xPosInWin;
      this.iconWinBoard.y = this.yPosInWin;
      this.winFrameParent.addChild(this.iconWinBoard);
      parent.addChild(this);
    }
  }
}

export function getIconValueFromIconNumber(iconNumber) {
  return Number(iconNumber.toString().split('-')[1] || 0);
}
